<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">Wachtwoord wijzigen</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text class="pt-6">
			<v-alert v-if="mustResetCredentials" type="warning" dense outlined class="mb-4">
				U bent ingelogd met een tijdelijk wachtwoord uit de e-mail. Wijzig uw wachtwoord nu om verder te gaan.
			</v-alert>
			<v-alert v-if="formError" type="error" dense outlined class="mb-4">{{ formError }}</v-alert>
			<v-alert v-if="formSuccess" type="success" dense outlined class="mb-4">{{ formSuccess }}</v-alert>
			<p class="body-2 mb-4">
				Vul uw huidige wachtwoord in en kies een nieuw wachtwoord. Het nieuwe wachtwoord moet twee keer hetzelfde zijn.
			</p>
			<v-form ref="form" v-model="formValid">
				<v-text-field
					dense
					filled
					v-model="form.current_password"
					label="Huidig wachtwoord *"
					type="password"
					autocomplete="current-password"
					:rules="[rules.required]"
				></v-text-field>
				<v-text-field
					dense
					filled
					v-model="form.new_password"
					label="Nieuw wachtwoord *"
					type="password"
					autocomplete="new-password"
					:rules="[rules.required, rules.minLen]"
				></v-text-field>
				<v-text-field
					dense
					filled
					v-model="form.new_password_confirm"
					label="Nieuw wachtwoord (bevestigen) *"
					type="password"
					autocomplete="new-password"
					:rules="[rules.required, rules.matchNew]"
				></v-text-field>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" depressed :loading="saving" @click="submit">Opslaan</v-btn>
			<v-btn v-if="!mustResetCredentials" color="dark" depressed @click="goBack">Terug</v-btn>
			<v-btn v-else text color="secondary" depressed @click="logout">Uitloggen</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "ChangePassword",
	data() {
		var self = this;
		return {
			formValid: false,
			saving: false,
			formError: "",
			formSuccess: "",
			form: {
				current_password: "",
				new_password: "",
				new_password_confirm: ""
			},
			rules: {
				required: function(v) {
					return (v != null && String(v) !== "") || "Verplicht veld";
				},
				minLen: function(v) {
					return !v || String(v).length >= 6 || "Minimaal 6 tekens";
				},
				matchNew: function(v) {
					return v === self.form.new_password || "Moet overeenkomen met nieuw wachtwoord";
				}
			}
		};
	},
	computed: {
		username() {
			try {
				var u = JSON.parse(localStorage.getItem("user") || "{}");
				return u.username || "";
			} catch (e) {
				return "";
			}
		},
		mustResetCredentials() {
			try {
				var u = JSON.parse(localStorage.getItem("user") || "{}");
				return Number(u.reset_credentials) === 1;
			} catch (e) {
				return false;
			}
		}
	},
	methods: {
		logout() {
			this.$store.dispatch("logout");
			this.$router.replace({ path: "/" });
		},
		goBack() {
			this.$router.go(-1);
		},
		submit() {
			this.formError = "";
			this.formSuccess = "";
			if (!this.username) {
				this.formError = "Geen gebruiker gevonden. Log opnieuw in.";
				return;
			}
			if (this.$refs.form && !this.$refs.form.validate()) {
				return;
			}
			if (this.form.new_password !== this.form.new_password_confirm) {
				this.formError = "De nieuwe wachtwoorden komen niet overeen.";
				return;
			}
			var self = this;
			var forcedReset = self.mustResetCredentials;
			this.saving = true;
			ax.post("/public/portal_change_password", {
				username: this.username,
				current_password: this.form.current_password,
				new_password: this.form.new_password,
				new_password_confirm: this.form.new_password_confirm
			})
				.then(function(res) {
					var d = res.data;
					if (d && d.success) {
						self.$store.commit("PATCH_USER_FIELDS", { reset_credentials: null });
						if (forcedReset) {
							self.$router.replace({ path: "/main" });
						} else {
							self.formSuccess = d.msg || "Uw wachtwoord is gewijzigd.";
							self.form.current_password = "";
							self.form.new_password = "";
							self.form.new_password_confirm = "";
							if (self.$refs.form) {
								self.$refs.form.resetValidation();
							}
						}
					} else {
						self.formError = (d && d.msg) || "Wachtwoord wijzigen is mislukt.";
					}
				})
				.catch(function(err) {
					var d = err.response && err.response.data;
					self.formError = (d && d.msg) || "Er is een fout opgetreden.";
				})
				.finally(function() {
					self.saving = false;
				});
		}
	}
};
</script>
